/* eslint-disable import/no-anonymous-default-export */
export default {
  suppliers: {
    list: [],
    activeID: null,
    activeUUID: null,
    loading: false,
  },
};
